import { MainInner, StyledMainSection } from "@/styles/global";
import styled from "styled-components";

const Section = styled(StyledMainSection)``;

const Inner = styled(MainInner)`
  max-width: 1200px;
`;

const ImageContainer = styled.div<{ $size?: "large" | "small" | "video" }>`
  position: relative;
  width: 100%;
  aspect-ratio: ${({ $size }) =>
    $size === "large"
      ? " 617/358 "
      : $size === "video"
        ? "16 / 9"
        : "358 / 350"};
  overflow: hidden;
  border-radius: 21px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    aspect-ratio: ${({ $size }) =>
      $size === "large"
        ? "1337 / 741"
        : $size === "video"
          ? "16 / 9"
          : "1337 / 515"};
  }
`;

const VideoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 21px;
  overflow: hidden;
`;

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transition: all 0.2s ease-in-out;
  border-radius: 21px;
  background:
    linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%),
    0px -125.459px / 100% 119.827% no-repeat;
  pointer-events: none;
`;

const TextContainer = styled.div`
  margin: auto;
  margin-bottom: 56px;
  padding: 16px;
  z-index: 1;
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: 48px;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 60%;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin: 0 0 auto auto;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    margin: auto 0 0 auto;
    gap: 24px;
  }
`;

const ButtonsContainer = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 10;

  svg {
    width: 48px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    bottom: 48px;
    right: 48px;

    svg {
      width: 60px;
    }
  }
`;

const S = {
  Section,
  Inner,
  ImageContainer,
  VideoContainer,
  Overlay,
  TextContainer,
  TextWrapper,
  ButtonWrapper,
  ButtonsContainer,
};

export default S;
